import * as images from "@/components/images/Images";
import { CasesCardProps } from "@/components/screen/global-components/cases/CasesCard";

const industriesCardsContent = {
  title: "Translators specialized in your business",
  description:
    "Accurate, context-aware precision for even the most technical and complex professional business translations",
} as const;

const industriesCardsCards: CasesCardProps[] = [
  {
    title: "Automotive",
    description:
      "Languex translates manuals, safety docs, CAD drawings, and supplier agreements, ensuring precise automotive terminology for manufacturers, suppliers, and dealerships.",
    imageUrl: images.translatorsImg1,
    link: "/industries/automotive",
    linkLabel: "Learn more",
  },
  {
    title: "Construction",
    description:
      "We translate blueprints, contracts, safety regulations, and bid proposals, ensuring accuracy in engineering terminology and compliance with global building codes.",
    imageUrl: images.translatorsImg2,
    link: "/industries/construction",
    linkLabel: "Learn more",
  },
  {
    title: "E-commerce",
    description:
      "Languex translates product descriptions, labels, packaging, websites, and manuals and more ensuring accurate, engaging content that resonates with global customers.",
    imageUrl: images.translatorsImg3,
    link: "/industries/ecommerce",
    linkLabel: "Learn more",
  },
  {
    title: "Education",
    description:
      "We support translations for research, e-learning, university applications, and course materials, ensuring clarity and accuracy in specialized academic terminology.",
    imageUrl: images.translatorsImg4,
    link: "/use-cases/academic",
    linkLabel: "Learn more",
  },
  {
    title: "Energy and Utilities",
    description:
      "Languex translates reports, safety regulations, environmental studies, and compliance documents, ensuring technical accuracy for oil, gas, and renewable energy.",
    imageUrl: images.translatorsImg5,
    link: "/industries/energy-utilities",
    linkLabel: "Learn more",
  },
  {
    title: "Finance",
    description:
      "We translate financial statements, tax documents, compliance reports, and crypto materials, ensuring accuracy, confidentiality, and adherence to industry standards.",
    imageUrl: images.translatorsImg6,
    link: "/use-cases/financial",
    linkLabel: "Learn more",
  },
  {
    title: "Gaming",
    description:
      "Languex translates in-game text, UI, dialogue, and marketing content, adapting games for global players while preserving cultural relevance and immersion.",
    imageUrl: images.translatorsImg7,
    link: "/industries/gaming",
    linkLabel: "Learn more",
  },
  {
    title: "Government",
    description:
      "We provide certified translations for policy reports, legal documents, immigration forms, and multilingual communications, ensuring accuracy and compliance.",
    imageUrl: images.translatorsImg8,
    link: "/industries/government",
    linkLabel: "Learn more",
  },
  {
    title: "Healthcare",
    description:
      "Languex provides HIPAA-compliant translations for medical records, clinical trials, and pharma documents, ensuring precision in healthcare communications.",
    imageUrl: images.translatorsImg9,
    link: "/use-cases/medical",
    linkLabel: "Learn more",
  },
  {
    title: "Insurance",
    description:
      "We translate policies, claims, underwriting documents, and risk assessments, ensuring clarity and compliance for insurers, brokers, and policyholders.",
    imageUrl: images.translatorsImg10,
    link: "/industries/insurance",
    linkLabel: "Learn more",
  },
  {
    title: "Law",
    description:
      "Languex translates affidavits, contracts, court records, and compliance documents, supporting legal professionals across multiple practice areas worldwide.",
    imageUrl: images.translatorsImg11,
    link: "/use-cases/legal",
    linkLabel: "Learn more",
  },
  {
    title: "Manufacturing",
    description:
      "We translate manuals, product specs, patents, and compliance documents, ensuring accurate technical terminology for manufacturers and global supply chains.",
    imageUrl: images.translatorsImg12,
    link: "/industries/manufacturing",
    linkLabel: "Learn more",
  },
  {
    title: "Media",
    description:
      "Languex translates subtitles, scripts, press releases, and social media, ensuring engaging, culturally adapted content for global media and entertainment.",
    imageUrl: images.translatorsImg13,
    link: "/industries/media",
    linkLabel: "Learn more",
  },
  {
    title: "Technology",
    description:
      "We translate software, apps, user manuals, and IT documentation, ensuring precise localization and seamless global adoption for tech products and platforms.",
    imageUrl: images.translatorsImg14,
    link: "/industries/technology",
    linkLabel: "Learn more",
  },
  {
    title: "Tourism",
    description:
      "Languex translates websites, brochures, travel guides, and booking platforms, ensuring culturally adapted, engaging content for international travelers.",
    imageUrl: images.translatorsImg15,
    link: "/industries/tourism",
    linkLabel: "Learn more",
  },
];

export const industriesCardsData = {
  ...industriesCardsContent,
  cards: industriesCardsCards,
};
